export const UPPER = [18, 17, 16, 15, 14, 13, 12, 11, 21, 22, 23, 24, 25, 26, 27, 28];
export const LOWER = [48, 47, 46, 45, 44, 43, 42, 41, 31, 32, 33, 34, 35, 36, 37, 38];

const NAMES = { 1: "Incisivo central", 2: "Incisivo lateral", 3: "Canino", 4: "1º Pré-molar", 5: "2º Pré-molar", 6: "1º Molar", 7: "2º Molar", 8: "3º Molar (siso)" };

export const toothName = (n) => {
  const q = Math.floor(n / 10);
  const arch = q <= 2 ? "superior" : "inferior";
  const side = q === 1 || q === 4 ? "direito" : "esquerdo";
  return `${NAMES[n % 10]} ${arch} ${side}`;
};

export const toothType = (n) => {
  const d = n % 10;
  if (d <= 2) return "incisor";
  if (d === 3) return "canine";
  if (d <= 5) return "premolar";
  return "molar";
};

// Drawn as an upper tooth (roots on top, crown at the bottom) in a 40x64 box.
export const SHAPES = {
  incisor: {
    roots: ["M14 31 Q14.5 12 20 3 Q25.5 12 26 31 Z"],
    crown: "M12 30 L28 30 Q31 43 29.5 58 Q20 61 10.5 58 Q9 43 12 30 Z",
  },
  canine: {
    roots: ["M13.5 31 Q14 8 20 0 Q26 8 26.5 31 Z"],
    crown: "M11 30 L29 30 Q31.5 44 27 53 L20 61 L13 53 Q8.5 44 11 30 Z",
  },
  premolar: {
    roots: ["M12.5 31 Q13 13 20 5 Q27 13 27.5 31 Z"],
    crown: "M9 30 L31 30 Q34.5 44 30.5 56 Q25 61 20 57.5 Q15 61 9.5 56 Q5.5 44 9 30 Z",
  },
  molar: {
    roots: ["M6 31 Q5.5 14 10.5 5 Q15.5 14 17 31 Z", "M23 31 Q24.5 14 29.5 5 Q34.5 14 34 31 Z"],
    crown: "M4 30 L36 30 Q39.5 44 35.5 56 Q31 61 27 57 Q23.5 61 20 57 Q16.5 61 13 57 Q9 61 4.5 56 Q0.5 44 4 30 Z",
  },
};

// Surface code for each drawn position of the 5-surface diagram.
export const surfaceAt = (n, pos) => {
  const q = Math.floor(n / 10);
  const upper = q <= 2;
  const rightIsMesial = q === 1 || q === 4;
  if (pos === "center") return "O";
  if (pos === "top") return upper ? "V" : "L";
  if (pos === "bottom") return upper ? "L" : "V";
  if (pos === "right") return rightIsMesial ? "M" : "D";
  return rightIsMesial ? "D" : "M";
};

export const SURFACE_LABELS = { V: "Vestibular", L: "Lingual / Palatina", M: "Mesial", D: "Distal", O: "Oclusal / Incisal" };
